﻿import {translation} from "@2d-front-monorepo/core";
import {MaterialIcon, Message, useRemoteData} from "@2d-front-monorepo/design-library";
import {PaymentHistoryEntry, Tariffs, Vehicles} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {API_ENDPOINT} from "../../api-endpoint";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import PermitsInlineLoading from "../../components/PermitsInlineLoading";
import {PermitsState} from "../../contexts/PermitsContext";
import {useHttpClient} from "../../hooks/useHttpClient";
import {usePermits} from "../../hooks/usePermits";
import {formatRoute} from "../../routes";
import { formatDateTime } from "../../functions";

type InvoiceControlProps = {
	permits: PermitsState,
	invoice: PaymentHistoryEntry,
}

function InvoiceControl({permits, invoice}: InvoiceControlProps): JSX.Element {
	const tariff = Tariffs.get(permits.holderData, invoice.tariffId);
	const vehicles = Vehicles.getAll(permits.permits, invoice.vehicleIds);

	return (
		<tr>
			<td>{tariff.title}</td>
			<td className="number">{invoice.operation.id}</td>
			<td className="date">{formatDateTime(invoice.startDate)}</td>
			<td className="text">{vehicles.map(((vehicle, index) => (
				<div key={index}>[{vehicle.plate}] {vehicle.data?.nickname}</div>)))}
			</td>
			<td className="actions">
				<a href={formatRoute(API_ENDPOINT.invoices, invoice.permitId, invoice.operation.id)} target="_blank" title={translation(PermitTranslations.preview)}>
					<MaterialIcon icon="preview"/>
				</a>
			</td>
		</tr>);
}

export default function Invoices(): JSX.Element {
	const {data, loading} = useRemoteData(() => useHttpClient().permits.listPayments());
	const permits = usePermits();

	if (loading){
		return <PermitsInlineLoading />;
	}

	if (data.length == 0) {
		return (<Message title={{text: "No invoices found"}} type="information"/>);
	}

	return (
		<>
			<h1>{translation(PermitTranslations.invoices_page__title)}</h1>
			<hr/>
			<div role="region" tabIndex={0} className="table--card">
				<table>
					<thead>
						<tr>
							<th>{translation(PermitTranslations.permit_type)}</th>
							<th className="number">{translation(PermitTranslations.invoice_id)}</th>
							<th className="date">{translation(PermitTranslations.date)}</th>
							<th className="text">{translation(PermitTranslations.vehicles)}</th>
							<th className="actions"></th>
						</tr>
					</thead>
					<tbody>{data.map(((invoice, index) =>
						<InvoiceControl key={index} permits={permits} invoice={invoice}/>))}
					</tbody>
				</table>
			</div>
		</>
	);
}
